module.exports = __webpack_public_path__ + "static/media/Seco.a91e6a79.svg";